import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import Image from '@UI/Image';
import Link from '@Navigation/Link';
import { WikiArticleData } from '@Types/Wiki';
import styles from './WikiArticle.module.css';

export interface WikiArticleProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  article: WikiArticleData;
}

const WikiArticle: FC<WikiArticleProps> = (props) => {
  const { className, article, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.article, className)}>
      <Link to={article.link}>
        <Image src={article.image} className={styles.poster} cnImage={styles.cnImage} />
      </Link>

      <Link to={article.category.link} className={styles.categoryTitle}>
        {article.category.title}
      </Link>

      <Link to={article.link} className={styles.articleTitle}>
        {article.title}
      </Link>
    </div>
  );
};

export default memo(WikiArticle);
